import SwiperCarousel from 'utils/swiper-carousel';

export default () => {
  const init = () => {
    const promoSlider = new SwiperCarousel('[data-promo-bar-slider]', {
      slidesPerView: 1,
      centeredSlides: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '[data-promo-bar-arrow-next]',
        prevEl: '[data-promo-bar-arrow-prev]',
      },
      on: {
        init: function onInit() {
          const wrapper = this.el.querySelector('.swiper-wrapper');
          if (wrapper) {
            wrapper.classList.remove('opacity-0');
            wrapper.classList.add('transition-opacity', 'duration-300');
          }
          
          // Show navigation buttons after initialization
          const prevButton = document.querySelector('[data-promo-bar-arrow-prev]');
          const nextButton = document.querySelector('[data-promo-bar-arrow-next]');
          if (prevButton) prevButton.classList.remove('opacity-0');
          if (nextButton) nextButton.classList.remove('opacity-0');
          
          // Add hover pause functionality to the entire slider container
          const swiperInstance = this;
          const sliderContainer = this.el;
          
          // Pause on mouse enter
          sliderContainer.addEventListener('mouseenter', () => {
            if (swiperInstance.autoplay) {
              swiperInstance.autoplay.stop();
            }
          });
          
          // Resume on mouse leave
          sliderContainer.addEventListener('mouseleave', () => {
            if (swiperInstance.autoplay) {
              swiperInstance.autoplay.start();
            }
          });
          
          // Add focus pause functionality
          sliderContainer.addEventListener('focusin', () => {
            if (swiperInstance.autoplay) {
              swiperInstance.autoplay.stop();
            }
          });
          
          sliderContainer.addEventListener('focusout', (e) => {
            // Resume autoplay when focus leaves the promo bar entirely
            if (!sliderContainer.contains(e.relatedTarget)) {
              if (swiperInstance.autoplay) {
                swiperInstance.autoplay.start();
              }
            }
          });
        }
      },
      breakpoints: {
        1024: {
          centeredSlides: true,
        },
        0: {
          centeredSlides: true,
        }
      }
    });

    return promoSlider;
  };

  init();
};
